// extracted by mini-css-extract-plugin
var _1 = "CalendarGridBodyMessage-moduleCalendarGridBodyMessage__w70n9";
export { _1 as "CalendarGridBodyMessage" }
